import React from 'react'
import { Alert } from 'components'
import { alerts as alertKeys } from 'keys'
import { useAlert } from 'components/Alerts/hooks'

const VersionMessagePopup = () => {
    const { setAlerts } = useAlert()

    return (
        <Alert
            systemUI
            title={"המערכת עוברת שדרוג"}
            footerActions={[]}
            handleAlert={() => setAlerts(alertKeys.versionMessage, false)}
        >
            <div>
                <div>{'ניתן יהיה לחזור ולהשתמש ביום ראשון כ"ו באדר תשפ"ו 15-03-2026'}</div>
            </div>
        </Alert>
    )
}

export default VersionMessagePopup